// extracted by mini-css-extract-plugin
export var button = "trans-button-module--button--82591";
export var lastSpan = "trans-button-module--lastSpan--bb8ee";
export var link = "trans-button-module--link--b3717";
export var linkDecorative = "trans-button-module--linkDecorative--03855";